export enum FormMode {
  Update = "UPDATE",
  Create = "Create",
}
